{
  "name": "@clerk/astro",
  "version": "3.2.6",
  "description": "Clerk SDK for Astro",
  "keywords": [
    "auth",
    "authentication",
    "astro",
    "astro-integration",
    "clerk",
    "typescript",
    "passwordless",
    "astro-component",
    "withastro"
  ],
  "homepage": "https://clerk.com/",
  "bugs": {
    "url": "https://github.com/clerk/javascript/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/clerk/javascript.git",
    "directory": "packages/astro"
  },
  "license": "MIT",
  "author": "Clerk",
  "sideEffects": false,
  "type": "module",
  "imports": {
    "#async-local-storage": {
      "workerd": "./dist/async-local-storage.server.js",
      "browser": "./dist/async-local-storage.client.js",
      "node": "./dist/async-local-storage.server.js",
      "default": "./dist/async-local-storage.server.js"
    }
  },
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "default": "./dist/index.js"
    },
    "./react": {
      "types": "./dist/react/index.d.ts",
      "default": "./dist/react/index.js"
    },
    "./client": {
      "types": "./dist/client/index.d.ts",
      "default": "./dist/client/index.js"
    },
    "./internal": {
      "types": "./dist/internal/index.d.ts",
      "default": "./dist/internal/index.js"
    },
    "./server": {
      "types": "./dist/server/index.d.ts",
      "default": "./dist/server/index.js"
    },
    "./webhooks": {
      "types": "./dist/webhooks.d.ts",
      "default": "./dist/webhooks.js"
    },
    "./types": "./dist/types/index.d.ts",
    "./env": "./env.d.ts",
    "./components": "./components/index.ts",
    "./package.json": "./package.json"
  },
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "files": [
    "dist",
    "client",
    "server",
    "internal",
    "components",
    "webhooks",
    "env.d.ts",
    "types.ts"
  ],
  "scripts": {
    "build": "tsup --onSuccess \"pnpm build:dts\" && pnpm copy:components",
    "build:dts": "tsc --emitDeclarationOnly --declaration",
    "copy:components": "rm -rf ./components && mkdir -p ./components/ && cp  -r ./src/astro-components/* ./components/ && cp ./src/types.ts ./",
    "dev": "tsup --watch",
    "dev:pub": "pnpm dev -- --env.publish",
    "format": "node ../../scripts/format-package.mjs",
    "format:check": "node ../../scripts/format-package.mjs --check",
    "lint": "eslint src env.d.ts",
    "lint:attw": "attw --pack . --profile esm-only --ignore-rules internal-resolution-error",
    "lint:publint": "pnpm copy:components && publint",
    "test": "vitest run"
  },
  "dependencies": {
    "@clerk/backend": "workspace:^",
    "@clerk/shared": "workspace:^",
    "nanoid": "5.1.6",
    "nanostores": "1.0.1"
  },
  "devDependencies": {
    "@clerk/ui": "workspace:^",
    "astro": "^6.0.0"
  },
  "peerDependencies": {
    "astro": "^4.15.0 || ^5.0.0 || ^6.0.0"
  },
  "engines": {
    "node": ">=20.9.0"
  },
  "publishConfig": {
    "access": "public"
  }
}
